"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
exports.CSS = {
    container: 'c-PhotomeasureButton',
};
exports.Style = {
    [exports.CSS.container]: {
        transform: 'rotate(-90deg)',
    },
};
//# sourceMappingURL=photomeasure.button.style.js.map